import React from 'react';
import store from '@/store';
import AvatarDropdown from '@/components/AvatarDropdown';
import LocaleSwitch from '../LocaleSwitch';
import SiteSetting from '../SiteSetting';
import { LOGO, TITLE } from '@/utils/config';
import './index.less';

const EmptyHeader = () => {
  const [userState] = store.useModel('user');

  return (
    <div className="empty-header">
      <div className="left-content">
        {/* <div className="site-icon">
           <img
             className="icon"
             src={siteSettingsState?.logo ? siteSettingsState?.logo : LOGO}
           />
           <div className="name">
             {$i18n.language === 'zh-CN' ? siteSettingsState?.name?.zh_CN : siteSettingsState?.name?.en_US}
           </div>
          </div> */}
        <div className="home-icon" style={{ cursor: 'default' }}>
          <img
            className="icon"
            src={LOGO}
          />
          <span>
            {TITLE}
          </span>
        </div>
      </div>
      <div className="right-content">
        <SiteSetting />
        <LocaleSwitch />
        <AvatarDropdown
          avatar={userState.currentUser.userAvatar}
          name={userState.currentUser.userNick}
        />
      </div>
    </div>
  );
};

export default EmptyHeader;
